import { useMemo } from 'react';
import { useHasBulkEmailAccess, useHasBulkTextAccess } from '@frontend/feature-access';
import { useLocationIdsField } from '../../hooks/use-location-ids-field';
import { useSortDropdownField } from '../../hooks/use-sort-dropdown-field';
import { useYearDropdownField } from '../../hooks/use-year-dropdown-field';
import { CampaignListHeader } from '../campaign-list-header/campaign-list-header';
import { EmptyStateNoAccess } from '../empty-state-no-access';
import { EmptyStateNoFeatures } from '../empty-state-no-features';
import { DraftsListBody } from './drafts-list-body';

// TODO: Implement search when the backend is ready
export const DraftsList = () => {
  const { hasBulkEmailAccess, hasBulkEmailFlagEnabled, locationsWithBulkEmailAccess } = useHasBulkEmailAccess();
  const { hasBulkTextAccess, hasBulkTextFlagEnabled, locationsWithBulkTextAccess } = useHasBulkTextAccess();

  const hasAccess = hasBulkEmailAccess || hasBulkTextAccess;
  const hasFeature = hasBulkEmailFlagEnabled || hasBulkTextFlagEnabled;

  const accessibleLocations = useMemo(
    () => Array.from(new Set([...locationsWithBulkEmailAccess, ...locationsWithBulkTextAccess])),
    [locationsWithBulkEmailAccess, locationsWithBulkTextAccess]
  );

  const { locationsFieldProps, selectedLocationIds } = useLocationIdsField(accessibleLocations);
  const { sortDropdownFieldProps, sortDirection: selectedSort } = useSortDropdownField();
  const { yearDropdownFieldProps, selectedYear } = useYearDropdownField();

  if (!hasFeature) {
    return <EmptyStateNoFeatures />;
  }

  if (!hasAccess) {
    return <EmptyStateNoAccess />;
  }

  return (
    <>
      <CampaignListHeader
        accessibleLocations={accessibleLocations}
        locationsFieldProps={locationsFieldProps}
        sortDropdownFieldProps={sortDropdownFieldProps}
        yearDropdownFieldProps={yearDropdownFieldProps}
      />
      <DraftsListBody
        selectedLocationIds={selectedLocationIds}
        selectedSort={selectedSort}
        selectedYear={selectedYear}
      />
    </>
  );
};
